import { useImpersonation } from "@/contexts/ImpersonationContext";
import { useChatChannels } from "@/hooks/use-chat-channels";

/**
 * Antall uleste i Chat-rommet til menyvalget «Chat» (VIB-3022). Samme kilde
 * som kanallisten, så tallet i menyen og summen i listen er alltid like.
 */
export function useChatUnreadBadge(enabled: boolean): number {
  const { selfUser } = useImpersonation();
  return useChatChannels(selfUser?.id ?? null, enabled).totalUnread;
}
